import { getEventInstanceStatuses } from '../endpoints/getEventInstanceStatuses';

/** Current instance status of one event definition (UI-facing, camelCase). */
export interface EventInstanceStatus {
  readonly active: boolean;
  readonly total: number;
  readonly lastActiveAt: string | null;
}

/**
 * Instance status for a set of event definitions, keyed by `event_id`. Empty input → empty map.
 * Events with no status row simply map to nothing (the caller renders them as unknown until then).
 */
export const getEventInstanceStatus = async (eventIds: readonly number[]): Promise<Map<number, EventInstanceStatus>> => {
  const statuses = await getEventInstanceStatuses(eventIds);
  return new Map(
    statuses.map((s) => [
      s.event_id,
      {
        active: s.status_active,
        total: s.status_total,
        lastActiveAt: s.status_last_at,
      },
    ])
  );
};
